import React from 'react';
import { Rocket } from 'lucide-react';
import { Button } from './ui/button';
import { trustedCompanies } from '../mock';

const TrustedAndCTA = ({ onGetStarted }) => {
  return (
    <section className="relative py-16">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        {/* Trusted */}
        <div className="text-center mb-6">
          <div className="text-[12.5px] text-gray-500">Trusted by innovative companies and entrepreneurs</div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mb-14 items-center">
          {trustedCompanies.map((c) => (
            <div key={c.name} className="flex flex-col items-center opacity-60 hover:opacity-100 transition-opacity">
              <div className="text-white font-black text-[14px] tracking-tight">{c.name}</div>
              <div className="text-gray-500 text-[8.5px] tracking-[0.2em] mt-0.5">{c.subtitle}</div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="relative rounded-2xl overflow-hidden border border-[#a855f7]/20 bg-gradient-to-br from-[#0f0820] via-[#0a0616] to-[#0a0a1a] p-8 lg:p-10">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(168,85,247,0.15),transparent_60%)]" />

          <div className="relative grid lg:grid-cols-[1fr_auto] gap-8 items-center">
            <div>
              <h3 className="text-white text-[26px] lg:text-[30px] font-bold tracking-tight">
                Ready to Build Something Amazing?
              </h3>
              <p className="text-gray-400 text-[14px] mt-2 max-w-[520px]">
                Join thousands of founders and businesses building their future with BLKPixel Technologies.
              </p>
              <Button
                onClick={onGetStarted}
                className="mt-5 h-11 px-6 rounded-md text-[13.5px] font-semibold bg-gradient-to-r from-[#7c3aed] to-[#4f46e5] hover:from-[#8b45f0] hover:to-[#5b52ee] text-white shadow-[0_0_25px_rgba(124,58,237,0.4)] border-0"
              >
                Get Started Today →
              </Button>
            </div>

            <div className="relative w-[180px] h-[140px] lg:w-[240px] lg:h-[180px] mx-auto">
              <div className="absolute inset-0 bg-gradient-to-br from-[#a855f7]/30 to-[#4f46e5]/10 blur-3xl" />
              <div className="relative w-full h-full flex items-center justify-center">
                <Rocket className="w-24 h-24 text-[#a855f7]" strokeWidth={1.2} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedAndCTA;
